import { ProductDetail, RelatedProduct, FAQItem, Review } from '@/types/product';

// Los datos de productos relacionados y otros productos ahora están centralizados en src/data/products.ts

export const productReviews: Review[] = [
  {
    id: "1",
    name: "Esther R.",
    date: "14/5/25",
    rating: 5,
    comment: "Conocía este producto desde hacía tiempo pero no lo encontraba en los supermercados de mi barrio. Así que los compré por aquí. Entrega correcta el día previsto.",
    isVerified: true,
    helpful: 3,
    notHelpful: 0
  },
  {
    id: "2",
    name: "Mónica H.",
    date: "10/5/25",
    rating: 5,
    comment: "Siempre las compramos cuando viajamos a Italia. Es estupendo que ahora estén disponibles aquí. Las compro también para regalar a mi seres queridos.",
    isVerified: true,
    helpful: 5,
    notHelpful: 1
  },
  {
    id: "3",
    name: "Esther R.",
    date: "2/5/25",
    rating: 5,
    comment: "Conocía este producto desde hacía tiempo pero no lo encontraba en los supermercados de mi barrio. Así que los compré por aquí. Entrega correcta el día previsto.",
    isVerified: true,
    helpful: 2,
    notHelpful: 0
  },
  {
    id: "4",
    name: "Mónica H.",
    date: "28/4/25",
    rating: 5,
    comment: "Siempre las compramos cuando viajamos a Italia. Es estupendo que ahora estén disponibles aquí. Las compro también para regalar a mi seres queridos.",
    isVerified: true,
    helpful: 4,
    notHelpful: 0
  },
  {
    id: "5",
    name: "Mónica H.",
    date: "26/4/25",
    rating: 5,
    comment: "Siempre las compramos cuando viajamos a Italia. Es estupendo que ahora estén disponibles aquí. Las compro también para regalar a mi seres queridos.",
    isVerified: true,
    helpful: 1,
    notHelpful: 0
  },
  {
    id: "6",
    name: "Carlos M.",
    date: "24/4/25",
    rating: 4,
    comment: "Excelente calidad, muy buenas galletas. El sabor es auténtico italiano. Recomendadas 100%.",
    isVerified: true,
    helpful: 2,
    notHelpful: 0
  },
  {
    id: "7",
    name: "Ana L.",
    date: "22/4/25",
    rating: 5,
    comment: "Las mejores galletas que he probado. El sabor a chocolate y avellana es perfecto.",
    isVerified: true,
    helpful: 3,
    notHelpful: 0
  }
];

export const faqItems: FAQItem[] = [
  {
    title: "¿CUÁL ES EL PESO NETO DEL PAQUETE DE GALLETAS PAN DI STELLE?",
    content: "El paquete de galletas Pan di Stelle tiene un peso neto de 350 gramos, lo que equivale aproximadamente a 28-30 galletas. Este formato es ideal tanto para consumo individual como para compartir en familia."
  },
  {
    title: "¿CUÁNTO TIEMPO SE PUEDEN CONSERVAR LAS GALLETAS UNA VEZ ABIERTO EL PAQUETE?",
    content: "Una vez abierto el paquete, las galletas Pan di Stelle mantienen sus propiedades organolépticas durante aproximadamente 2-3 semanas si se conservan adecuadamente. Para mantener su frescura, te recomendamos guardarlas en un recipiente hermético en un lugar fresco y seco, alejado de la luz directa del sol."
  },
  {
    title: "¿LAS GALLETAS PAN DI STELLE CONTIENEN ALÉRGENOS?",
    content: "Sí, las galletas Pan di Stelle contienen varios alérgenos que es importante tener en cuenta:\n\n• Contienen trigo (gluten)\n• Contienen leche y derivados lácteos\n• Contienen huevo\n• Contienen avellanas\n\nPueden contener trazas de otros frutos secos. No son aptas para personas celíacas o con intolerancias a estos ingredientes."
  },
  {
    title: "¿CUÁL ES EL TIEMPO DE ENTREGA HABITUAL DEL PRODUCTO?",
    content: "El tiempo de entrega estándar es de 24-48 horas laborables para pedidos realizados antes de las 14:00h. Para entregas a Islas Canarias, Baleares, Ceuta y Melilla, el tiempo de entrega puede extenderse hasta 72-96 horas laborables. Recuerda que para pedidos superiores a 70€, el envío es gratuito."
  },
  {
    title: "¿SE PUEDEN CONGELAR LAS GALLETAS PARA CONSERVARLAS MÁS TIEMPO?",
    content: "Aunque técnicamente es posible congelar las galletas Pan di Stelle, no lo recomendamos ya que puede afectar a su textura y sabor característicos. Las galletas están diseñadas para consumirse a temperatura ambiente y, si se conservan adecuadamente en su envase original o en un recipiente hermético, mantendrán sus propiedades durante todo su período de consumo preferente."
  }
]; 